import { FC, ReactNode } from 'react';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import Sidebar from '../Sidebar/Sidebar';

interface LayoutProps {
  children: ReactNode;
}

const Layout: FC<LayoutProps> = ({ children }: LayoutProps) => {
  return (
    <div className="container body " style={{ minHeight: '100vh', backgroundColor: '#f7f7f7' }}>
      <div className="main_container" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Header />
        <Sidebar />
        <div className="right_col" role="main" style={{ flex: '1 0 auto' }}>
          {children}
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
